<div
  [id]="'care-provider-' + itemIndex()"
  [ngClass]="{
    'border-blueberry-3': careproviderUnit().isDigital && !careproviderUnit().isAbroad,
    'border-apricot-1': careproviderUnit().isAbroad,
    'border-grey-9': !careproviderUnit().isDigital && !careproviderUnit().isAbroad
  }"
  class="relative rounded-xl bg-white top-container p-4 flex flex-col xl:flex-row justify-between xl:items-stretch gap-4 border"
>
  <div class="image-section flex w-full xl:w-80 xl:basis-80 h-auto">
    <app-search-careprovider-unit-item-img-v2
      [careproviderRouterLink]="careproviderRouterLink()"
      [class]="'test-img-' + itemIndex()"
      [hasImage]="hasImage()"
      [imageUrl]="imageUrl()"
      [isCustomer]="careproviderUnit()?.isCustomer"
      [isPriorityImage]="isPriorityImage()"
      [itemIndex]="itemIndex()"
      [logoUrl]="logoUrl()"
      [mainCaregiverUnitType]="careproviderUnit()?.mainCaregiverUnitType"
      [mainSegment]="mainSegment()"
      [name]="careproviderUnit()?.name"
      [rating]="careproviderUnit()?.rating"
      [reviesCount]="careproviderUnit()?.reviesCount"
      class="w-full xl:w-80 aspect-[314/136]"
    ></app-search-careprovider-unit-item-img-v2>
  </div>
  <div class="w-full flex flex-col gap-4">
    <div class="flex flex-col 2xl:flex-row justify-between items-start flex-wrap 2xl:flex-nowrap">
      <div class="info-section w-full flex flex-col gap-1 order-2 2xl:order-1">
        <div class="item-title line-clamp-2">
          <a
            [class]="'test-title-' + itemIndex()"
            [routerLink]="careproviderRouterLink()"
            class="text-xl font-bold text-green-1 hover:text-apricot-1"
          >
            {{ careproviderUnit().name }}
          </a>
        </div>

        <div class="flex flex-row gap-5 justify-start items-center">
          @if (careproviderUnit().address && !careproviderUnit().isDigital && address()) {
            <div class="inline-flex items-center">
              <app-ui-icon
                class="mr-1"
                color="var(--grey-3)"
                name="marker"
                size="sm"
              ></app-ui-icon>
              <a
                (click)="openMap()"
                [class]="'test-address-' + itemIndex()"
                class="text-green-2 text-sm hover:text-green-1"
              >
                {{ address() }}
              </a>
            </div>
          }
        </div>
      </div>

      @if (careproviderUnit().isDigital || careproviderUnit().isBoosted || careproviderUnit().isAbroad) {
        <app-search-careprovider-unit-item-labels
          [isAbroad]="careproviderUnit().isAbroad"
          [isBoosted]="careproviderUnit().isBoosted"
          [isDigital]="careproviderUnit().isDigital"
          class="block mb-2 2xl:mb-0 order-1 2xl:order-2 w-fit h-8 relative"
        ></app-search-careprovider-unit-item-labels>
      }
    </div>

    @if (listaDigDirectCF() || listaDigVarden()) {
      <div class="w-full flex justify-between gap-2 2xl:justify-start">
        @if (listaDigDirectCF()) {
          <app-customer-feature
            [class]="'grow 2xl:grow-0 test-customer-feature-btn-' + itemIndex() + '-0'"
            [color]="'outline-tertiary'"
            [feature]="listaDigDirectCF()"
            [isCustomer]="careproviderUnit()?.isCustomer"
            [label]="featureLabel()"
            [pageType]="pageType()"
          ></app-customer-feature>
        }

        @if (listaDigVarden()) {
          <app-customer-feature
            [class]="'grow 2xl:grow-0 test-customer-feature-btn-' + itemIndex() + '-1'"
            [color]="'outline-tertiary'"
            [feature]="listaDigVarden()"
            [isCustomer]="careproviderUnit()?.isCustomer"
            [label]="featureLabel()"
            [pageType]="pageType()"
          ></app-customer-feature>
        }
      </div>
    }

    @if (visibleCareServices().length === 0) {
      <div class="booking-section w-full flex flex-col mb-2">
        <hr class="mb-2">

        @if (!showHomepage() && !showPhone()) {
          <div class="text-sm text-grey-1">
            Inga tillgängliga tjänster att boka online
          </div>
        }
        @if (showHomepage() || showPhone()) {
          <div class="text-sm text-grey-1">
            Vill du komma i kontakt med mottagningen?
          </div>
        }

        @if (showHomepage() || showPhone()) {
          <div class="flex mt-3 gap-2 justify-between xl:justify-start">
            @if (showHomepage()) {
              <div class="block grow xl:inline-block xl:grow-0">
                <app-ui-button
                  (click)="openCpruContact()"
                  [eventAction]="eventActionEnum.HSA_CTA_WEBSITE"
                  [eventCategory]="eventCategoryEnum.HSA_CTA"
                  [eventLabel]="careproviderUnit().id.toString()"
                  [eventParams]="generateDataLayerParamsClickGA4(
                    eventCategoryEnum.HSA_CTA + ' - ' + eventActionEnum.HSA_CTA_WEBSITE,
                    null,
                    null
                  )"
                  appGtmEvent
                  appGtmGa4Event
                  class="grow"
                  color="tertiary"
                  expanded="block"
                  size="md"
                >
                  <app-ui-icon
                    class="icon"
                    color="var(--green-1)"
                    name="website"
                    size="lg"
                  ></app-ui-icon>
                  Hemsida
                </app-ui-button>
              </div>
            }
            @if (showPhone()) {
              <div class="block grow xl:inline-block xl:grow-0">
                <app-ui-button
                  (click)="openCpruContact()"
                  [eventAction]="eventActionEnum.HSA_CTA_PHONE"
                  [eventCategory]="eventCategoryEnum.HSA_CTA"
                  [eventLabel]="careproviderUnit().id.toString()"
                  [eventParams]="generateDataLayerParamsClickGA4(
                    eventCategoryEnum.HSA_CTA + ' - ' + eventActionEnum.HSA_CTA_PHONE,
                    null,
                    null
                  )"
                  appGtmEvent
                  appGtmGa4Event
                  class="grow"
                  color="tertiary"
                  expanded="block"
                  size="md"
                >
                  <app-ui-icon
                    class="icon"
                    color="var(--green-1)"
                    name="phone"
                    size="lg"
                  ></app-ui-icon>
                  Telefon
                </app-ui-button>
              </div>
            }
          </div>
        }
      </div>
    }

    @if (visibleCareServices().length > 0) {
      <div class="booking-section w-full flex flex-col grow">
        <div [id]="'care-provider-' + itemIndex() + '-list'">
          @for (item of visibleCareServices(); let i = $index; track item.id) {
            <div class="mt-4 first:mt-0">
              <hr class="mb-4">

              <div class="line-clamp-2">
                <a
                  [class]="'test-category-' + itemIndex() + '-' + i"
                  [routerLink]="item?.routerLink"
                  class="text-lg font-bold text-duck-blue-2 mr-2"
                >
                  {{ item?.name }}
                </a>
              </div>
              @if (item?.price) {
                <div class="flex justify-start items-center gap-1.5 w-fit">
                  @if (!item?.priceDescription) {
                    <div
                      [class]="'test-price-label-' + itemIndex() + '-' + i"
                      class="text-grey-0 text-sm font-medium"
                    >
                      @if (item?.isFromPrice) {
                        fr.
                      }{{ item?.price }} kr
                    </div>
                  }

                  @if (item?.priceDescription) {
                    <div
                      #tooltip="matTooltip"
                      (click)="tooltip.toggle()"
                      (mouseover)="tooltip.toggle()"
                      [class]="'test-price-label-from-' + itemIndex() + '-' + i"
                      [matTooltip]="item?.priceDescription"
                      class="text-grey-0 text-sm font-medium cursor-pointer flex items-center justify-start"
                      matTooltipClass="varden-tooltip"
                      matTooltipPosition="above"
                    >
                      <span>
                        @if (item?.isFromPrice) {
                          fr.
                        }{{ item?.price }} kr
                      </span>
                      <app-ui-icon
                        color="var(--grey-0)"
                        name="info"
                        size="sm"
                      ></app-ui-icon>
                    </div>
                  }
                </div>
              }

              <div
                class="mt-3 flex flex-col justify-stretch gap-2 2xl:justify-start 2xl:flex-row 2xl:flex-wrap 3xl:flex-nowrap">
                @if ((showNextMonthTimeslots &&
                  item?.careServiceBookingSettings?.bookingType?.name === bookingTypeEnum.VARDEN &&
                  item?.timeslotDetails?.length === 0) || item?.timeslotDetails.length > 0) {
                  <div
                    [ngClass]="{'xl:basis-36': showNextMonthTimeslots &&
                      item?.careServiceBookingSettings?.bookingType?.name === bookingTypeEnum.VARDEN &&
                      item?.timeslotDetails?.length === 0}"
                    class="flex flex-row justify-stretch gap-2 lg:justify-start items-center"
                  >
                    @if (showNextMonthTimeslots &&
                    item?.careServiceBookingSettings?.bookingType?.name === bookingTypeEnum.VARDEN &&
                    item?.timeslotDetails?.length === 0) {
                      <div class="title-8 medium text-error xl:basis-36">
                        Inga lediga tider den närmaste månaden
                      </div>
                    }

                    @for (timeslot of item?.timeslotDetails; let j = $index; track timeslot.label) {
                      <app-ui-button
                        [class]="'test-timeslot-' + itemIndex() + '-' + i + '-' + j"
                        [eventAction]="eventActionEnum.VARDEN_BOOKING_CLICK_CARE_SERVICE_TIMESLOT_BTN"
                        [eventCategory]="eventCategoryEnum.VARDEN_BOOKING"
                        [eventLabel]="item?.id.toString()"
                        [eventParams]="generateDataLayerParamsClickGA4(
                          eventCategoryEnum.VARDEN_BOOKING + ' - ' + eventActionEnum.VARDEN_BOOKING_CLICK_CARE_SERVICE_TIMESLOT_BTN,
                          item,
                          i
                        )"
                        [ngClass]="{'hidden': j >= 2}"
                        (click)="navigateToBookingUrl(timeslot?.routerLink, timeslot?.queryParams)"
                        appGtmEvent
                        appGtmGa4Event
                        class="grow"
                        color="green"
                        expanded="block"
                        rel="nofollow"
                        size="md"
                      >
                        {{ timeslot?.label }}
                      </app-ui-button>
                    }
                  </div>
                }

                <div class="flex flex-col justify-stretch gap-2 2xl:justify-start 2xl:flex-row">
                  @for (buttonConfig of item?.bookingConfigurationDataSection1; track buttonConfig.id) {
                    <div>
                      <app-booking-btn
                        [bookingConfigurationData]="buttonConfig"
                        [caregiverContactInfo]="careproviderUnit()?.caregiverContactInfo"
                        [classList]="'b1 test-booking-btn-' + itemIndex() + '-' + i"
                        [gaEventAction]="eventActionEnum.VARDEN_BOOKING_CLICK_MAIN_BOOKING_BTN"
                        [gaEventCategory]="eventCategoryEnum.VARDEN_BOOKING"
                        [gaEventLabel]="careproviderUnit()?.id.toString()"
                        [hasTimeslots]="item?.timeslotDetails?.length > 0"
                        [index]="itemIndex()"
                        [mainCaregiverUnitType]="careproviderUnit()?.mainCaregiverUnitType"
                        [pageType]="pageType()"
                      ></app-booking-btn>
                    </div>
                  }

                  @for (buttonConfig of item?.bookingConfigurationDataSection2; track buttonConfig.id) {
                    <div>
                      <app-booking-btn
                        [bookingConfigurationData]="buttonConfig"
                        [caregiverContactInfo]="careproviderUnit()?.caregiverContactInfo"
                        [class]="'test-booking-btn-' + itemIndex() + '-' + i"
                        [gaEventAction]="eventActionEnum.VARDEN_BOOKING_CLICK_MAIN_BOOKING_BTN"
                        [gaEventCategory]="eventCategoryEnum.VARDEN_BOOKING"
                        [gaEventLabel]="careproviderUnit()?.id.toString()"
                        [hasTimeslots]="item?.timeslotDetails?.length > 0 || item?.careServiceBookingSettings?.bookingType?.name === bookingTypeEnum.VARDEN"
                        [index]="itemIndex()"
                        [mainCaregiverUnitType]="careproviderUnit()?.mainCaregiverUnitType"
                        [pageType]="pageType()"
                      ></app-booking-btn>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>

        @if (careproviderUnit().careServices.length > 1) {
          <div
            (click)="seeMore()"
            class="w-full mt-3 grow flex items-end"
          >
            <a
              *ngIf="hasMore(); else seeLess"
              [class]="'test-see-more-' + itemIndex()"
              class="text-base font-medium text-green-2 hover:text-green-1 flex flex-row items-center justify-center w-full gap-2"
            >
              <app-ui-icon
                color="var(--green-2)"
                name="chevron_expand"
                size="sm"
              ></app-ui-icon>
              <span>Fler tjänster ({{ itemsLeft() }})</span>
            </a>

            <ng-template #seeLess>
              <a
                [class]="'test-see-less-' + itemIndex()"
                class="text-base font-medium text-green-2 hover:text-green-1 flex flex-row items-center justify-center w-full gap-2"
              >
                <app-ui-icon
                  color="var(--green-2)"
                  name="chevron_collapse"
                  size="sm"
                ></app-ui-icon>
                <span>Färre tjänster</span>
              </a>
            </ng-template>
          </div>
        }
      </div>
    }
  </div>
</div>
